export interface IStrategy {
	id: number;
	name: string;
}

/**
 * Not observable for now
 */
export class StrategyModel implements IStrategy {
	id: number;
	name: string;

	constructor(props: IStrategy) {
		this.id = props.id;
		this.name = props.name;
	}

	getId(): number {
		return this.id;
	}
	getName(): string {
		return this.name;
	}
	toJSON() {
		return {
			id: this.id,
			name: this.name,
		};
	}
}
